import { render, staticRenderFns } from "./EmdFooterExternal.vue?vue&type=template&id=36a6f1c9"
import script from "./EmdFooterExternal.vue?vue&type=script&lang=js"
export * from "./EmdFooterExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmdFooterExternal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a6f1c9')) {
      api.createRecord('36a6f1c9', component.options)
    } else {
      api.reload('36a6f1c9', component.options)
    }
    module.hot.accept("./EmdFooterExternal.vue?vue&type=template&id=36a6f1c9", function () {
      api.rerender('36a6f1c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/organisms/EmdFooterExternal.vue"
export default component.exports